export default __webpack_public_path__ + "static/media/m6.105eb3e2.svg";